import { useEffect } from 'react'

type Props = {
  message: string | null
  onDismiss: () => void
}

export default function AppFlash({ message, onDismiss }: Props) {
  useEffect(() => {
    if (!message) return
    const timer = window.setTimeout(onDismiss, 4500)
    return () => window.clearTimeout(timer)
  }, [message, onDismiss])

  if (!message) return null

  return (
    <div className="app-flash" role="status" aria-live="polite">
      <p className="app-flash__text">{message}</p>
      <button type="button" className="app-flash__close" onClick={onDismiss} aria-label="Close">
        ×
      </button>
    </div>
  )
}
